<template>
  <Instructions />
</template>

<script>
import Instructions from "./instructions";

export default {
  name: "home",
  components: {
    Instructions
  }
};
</script>
